import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

const STATUS_STYLE = {
  UNPAID: { color: '#dc2626', background: '#fef2f2', border: '1px solid #fca5a5' },
  PAID:   { color: '#16a34a', background: '#f0fdf4', border: '1px solid #86efac' },
  VOID:   { color: '#6b7280', background: '#f3f4f6', border: '1px solid #d1d5db' },
};

export default function BillList() {
  const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('UNPAID');

  useEffect(() => { load(); }, [filter]);

  async function load() {
    setLoading(true);
    let q = supabase.from('bills')
      .select('id, bill_number, payee, amount, bill_date, due_date, status, description, expense_account:expense_account_id(account_name, account_code)')
      .order('bill_date', { ascending: false });
    if (filter !== 'ALL') q = q.eq('status', filter);
    const { data } = await q;
    setBills(data || []);
    setLoading(false);
  }

  const totalUnpaid = bills.filter(b => b.status === 'UNPAID').reduce((s, b) => s + parseFloat(b.amount || 0), 0);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Bills</div>
          <div className="page-subtitle">Payables due to be settled</div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/bills/new')}>+ New Bill</button>
      </div>

      {/* Filter + summary */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        {['UNPAID', 'PAID', 'ALL'].map(s => (
          <button
            key={s}
            className={`btn ${filter === s ? 'btn-primary' : 'btn-secondary'} btn-sm`}
            onClick={() => setFilter(s)}
          >{s}</button>
        ))}
        {filter === 'UNPAID' && totalUnpaid > 0 && (
          <span style={{ marginLeft: 'auto', fontWeight: 700, color: '#dc2626', fontSize: 14 }}>
            Total Outstanding: LKR {totalUnpaid.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </span>
        )}
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '2px solid var(--border)', color: 'var(--text-muted)', fontSize: 11, textTransform: 'uppercase' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px' }}>Bill #</th>
              <th style={{ textAlign: 'left', padding: '10px 16px' }}>Payee</th>
              <th style={{ textAlign: 'left', padding: '10px 16px' }}>Expense Account</th>
              <th style={{ textAlign: 'left', padding: '10px 16px' }}>Bill Date</th>
              <th style={{ textAlign: 'left', padding: '10px 16px' }}>Due Date</th>
              <th style={{ textAlign: 'right', padding: '10px 16px' }}>Amount (LKR)</th>
              <th style={{ textAlign: 'center', padding: '10px 16px' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center' }}><div className="spinner" /></td></tr>
            ) : bills.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center', color: 'var(--text-muted)' }}>No bills found.</td></tr>
            ) : bills.map(b => {
              const overdue = b.status === 'UNPAID' && b.due_date && b.due_date < new Date().toISOString().slice(0, 10);
              return (
                <tr
                  key={b.id}
                  onClick={() => navigate(`/bills/${b.id}`)}
                  style={{ borderBottom: '1px solid var(--border)', cursor: 'pointer', opacity: b.status === 'VOID' ? 0.5 : 1 }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--bg)'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}
                >
                  <td style={{ padding: '10px 16px', fontWeight: 600, color: 'var(--primary)' }}>{b.bill_number}</td>
                  <td style={{ padding: '10px 16px', fontWeight: 500 }}>{b.payee}</td>
                  <td style={{ padding: '10px 16px', color: 'var(--text-muted)' }}>{b.expense_account?.account_name}</td>
                  <td style={{ padding: '10px 16px' }}>{b.bill_date}</td>
                  <td style={{ padding: '10px 16px', color: overdue ? '#dc2626' : undefined, fontWeight: overdue ? 700 : undefined }}>
                    {b.due_date || '—'}{overdue ? ' ⚠ Overdue' : ''}
                  </td>
                  <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: 600 }}>
                    {parseFloat(b.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </td>
                  <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                    <span style={{ ...STATUS_STYLE[b.status], padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>
                      {b.status}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
